import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import styledComponents from '../styles/BoardContainer-style'
import Select from 'react-select';
import Axios from 'axios';
import Pagination from "./board/Pagination";

const { WebContainer, BoardInfoContainer, BoardVisualizeContainer, Row, InfoTitle, SelectRowContainer, SelectYearContainer } = styledComponents;

// 데이터 시각화 패널 컨테이너
const BoardContainer = (props) => {
    const [SelectedNttId, setSelectedNttId] = useState(0)
    const [nttInfo, setNttInfo] = useState([]);    
    const [nttFileList, setNttFileList] = React.useState([]);  
    const handleSelect = (index) => {
        setSelectedNttId(index);
        Axios.get(`${process.env.REACT_APP_API_HOST}/adm_bbs/info?board_seq=${index}`).then((response)=>{        
            setNttInfo(response.data);
        })
        Axios.get(`${process.env.REACT_APP_API_HOST}/adm_bbs/boardFileUserList?board_seq=${index}`).then((response)=>{        
            setNttFileList(response.data);
        })
    }
    
    // 게시글 조회시    
    const [posts, setPosts] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const offset = (page - 1) * limit;

    React.useEffect(()=>{
        Axios.get(`${process.env.REACT_APP_API_HOST}/adm_bbs/list`).then((response)=>{
            setPosts(response.data);
        })
    },[])
      
    const getValue = e => {
        const { name, value } = e.target;
        setnttSch({
            ...nttSch,
            [name]: value
        })
    };

    const [nttSch, setnttSch] = React.useState({
        sch_type: 'title',
        sch_text: ''
    })
    
    const submitSch = ()=>{
        let form = new FormData()
        form.append('sch_type',nttSch.sch_type)
        form.append('sch_text',nttSch.sch_text)
        Axios.get(`${process.env.REACT_APP_API_HOST}/adm_bbs/list?sch_type=${nttSch.sch_type}&sch_text=${nttSch.sch_text}`).then((response)=>{
            setPosts(response.data);
        })
    };

    return (
        <WebContainer>
            <BoardInfoContainer>
                <BoardVisualizeContainer>                           
                    {/* 면적 인포그래픽 */}
                    {SelectedNttId === 0 &&
                        <>
                            <div className="card-body">
                                <div className="form-group row float-left pl-3">                       
                                    <label className="col-form-label font-weight-bold">전체 {posts.length}건</label>
                                                                              
                                </div>
                                <div className="form-group row float-right pr-3">
                                    <div className="pr-1">
                                        <select
                                            className="form-control"
                                            type="number"
                                            value={limit}
                                            onChange={({ target: { value } }) => setLimit(Number(value))}
                                            >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <div className="pr-1">
                                        <select name="sch_type" className="form-control" onChange={getValue}>
                                        <option value="title">제목</option>
                                        <option value="content">내용</option>
                                    </select></div>
                                    <div className="pr-1">
                                        <input type="text" name="sch_text" value={nttSch.sch_text || ""} onChange={getValue} className="form-control" />
                                    </div>
                                    <button className="btn btn-primary" onClick={submitSch}>검색</button>                                              
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <colgroup>
                                            <col width="10%"/>
                                            <col width="*"/>
                                            <col width="15%"/>
                                            <col width="15%"/>
                                            <col width="15%"/>
                                        </colgroup>
                                        <thead>
                                            <tr className='text-center'>
                                                <th>번호</th>
                                                <th>제목</th>
                                                <th>작성자</th>
                                                <th>첨부파일</th>
                                                <th>작성일</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {posts.slice(offset, offset + limit).map((element,index) =>
                                            <tr key={posts.length - (page-1) * limit - index}>
                                                <td className='text-center'>{posts.length - (page-1) * limit - index}</td>
                                                <td>
                                                    <Link to="/home" onClick={() => handleSelect(`${element.board_seq}`)}>{element.title}</Link>
                                                </td>
                                                <td className='text-center'>{element.name}</td>
                                                <td className='text-center'>{element.file_cnt > 0 ?<img alt="BlueCarbon" src="./images/board/save_icon.svg"/>:''}</td>
                                                <td className='text-center'>{element.reg_date}</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                    <Pagination
                                        total={posts.length}
                                        limit={limit}
                                        page={page}
                                        setPage={setPage}
                                    />
                                </div>
                            </div>
                        </>
                    }
                    {SelectedNttId !== 0 &&
                        <>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered" id="page4myTable1">
                                        <colgroup>
                                            <col width="20%"/>
                                            <col width="30%"/>
                                            <col width="20%"/>
                                            <col width="30%"/>
                                        </colgroup>
                                        <thead></thead>
                                        <tbody >
                                            <tr>
                                                <td colSpan={4} className='text-center'>{nttInfo.title}</td>
                                            </tr>                    
                                            <tr className='text-center'>
                                                <th>작성일</th>
                                                <td>{nttInfo.reg_date}</td>
                                                <th>작성자</th>
                                                <td>{nttInfo.name}</td>
                                            </tr>
                                            <tr>
                                                <th className='text-center'>첨부파일</th>
                                                <td colSpan={3}>
                                                {nttFileList && nttFileList.map((row, index) => (
                                                    <div key={index}>
                                                        <span role="button" onClick={() => window.location.href= `${process.env.REACT_APP_API_HOST}/adm_bbs/boardFileDown?fileId=${row.fileId}`}>
                                                            {row.name_ori}
                                                        </span>
                                                    </div>
                                                ))}
                                                </td>
                                            </tr>                    
                                            <tr>                                                
                                                <td colSpan={4}>
                                                    <div style={{ minHeight: "35rem" }}> {nttInfo.content}</div>                                                
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>                            
                                <div className="pt-2">                                             
                                    <Link to="/home" onClick={() => handleSelect(0)}>
                                    <button className='btn btn-primary float-right mx-1 my-1'>목록</button>
                                    </Link>
                                </div>
                            </div>
                        </>
                    }
                </BoardVisualizeContainer>
            </BoardInfoContainer>            
        </WebContainer>
    )
};

export default BoardContainer;
